// Apolo — shared session-title helpers (sprint recents-claude-style, follow-up).
//
// PURE + dependency-free so BOTH the renderer (auto-title new sessions) and the
// Worker (backfill + LLM refine) use one source of truth. Kept in shared/ next
// to modelRegistry / featureList (imported via ../../../shared/…).

// Nomes genéricos que o auto-título/backfill devem substituir (alvo do rename).
const GENERIC_NAMES = new Set([
  'new session', 'nova sessão', 'nova sessao', 'general coding session',
  'sessão', 'sessao', 'session', 'untitled', 'sem nome', '(sem nome)',
  'sem título', 'sem titulo', 'nova conversa', 'new chat',
]);

export function isGenericName(name) {
  if (typeof name !== 'string') return true;
  const n = name.trim().toLowerCase();
  return n === '' || GENERIC_NAMES.has(n);
}

// Título heurístico da 1ª mensagem: tira /skills e @menções do começo, colapsa
// espaço, pega a 1ª linha, limita a ~6 palavras / 48 chars, capitaliza a inicial,
// sem pontuação final. Determinístico — o LLM refina depois, em background.
export function heuristicTitle(text, { maxWords = 6, maxChars = 48 } = {}) {
  if (typeof text !== 'string') return '';
  let s = (text.replace(/\r/g, '').split('\n').find((l) => l.trim()) || '').trim();
  // remove tokens iniciais de skill (/foo, /foo:bar) e menções (@arquivo)
  s = s.replace(/^(?:\s*(?:\/[a-z0-9:_-]+|@[^\s]+))+\s*/i, '').replace(/\s+/g, ' ').trim();
  if (!s) return '';
  let out = s.split(' ').slice(0, maxWords).join(' ');
  if (out.length > maxChars) out = out.slice(0, maxChars).replace(/\s+\S*$/, '').trim();
  out = out.replace(/[\s.,;:!?…-]+$/, '');
  return out ? out.charAt(0).toUpperCase() + out.slice(1) : '';
}

// Sanitiza o título vindo do LLM (refino em background): 1ª linha, sem aspas nem
// pontuação de borda, sem prefixos tipo "Título:", limitado. '' se não sobrar
// nada útil (aí mantém a heurística).
export function sanitizeLlmTitle(raw, { maxChars = 48 } = {}) {
  if (typeof raw !== 'string') return '';
  let s = (raw.split('\n').find((l) => l.trim()) || '').trim();
  s = s.replace(/^\s*(t[íi]tulo|title)\s*[:\-–]\s*/i, '');
  s = s.replace(/^["'“”‘’`]+|["'“”‘’`]+$/g, '').trim();
  if (s.length > maxChars) s = s.slice(0, maxChars).replace(/\s+\S*$/, '').trim();
  s = s.replace(/[\s.,;:!?…]+$/, '');
  return s ? s.charAt(0).toUpperCase() + s.slice(1) : '';
}
